import { render } from "./curriculumclassifyadd.vue?vue&type=template&id=542abf14"
import script from "./curriculumclassifyadd.vue?vue&type=script&lang=js"
export * from "./curriculumclassifyadd.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__